import React, {Component} from 'react';
import WrapperContentFromArticleForPopup from "./WrapperContentFromArticleForPopup";
import {showPopupNoteArticle} from "../popups/PopupNoteArticle";

class ReturnInstructionButton extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                {
                    !!this.props.note && this.props.note.length > 0 ? (
                        <button type="button" className="base-input green mb-3"
                                onClick={() => showPopupNoteArticle(<WrapperContentFromArticleForPopup note={this.props.note} />) }>
                            RETURN INSTRUCTION
                        </button>
                    ) : null
                }
            </>
        );
    }
}

export default ReturnInstructionButton;